import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { List } from 'foundations-components/transitional/components/List';
import TrialRedirectButton from './tx-120/TrialRedirectButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActivationSuccessFooter = ({
  ctaText,
  showTrialLoadingState,
  onSuccess = () => {},
  upgradeData,
  featureName
}) => {
  return /*#__PURE__*/_jsx(DialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(List, {
      marginBlockEnd: "300",
      children: showTrialLoadingState ? /*#__PURE__*/_jsx(LoadingSpinner, {
        showLabel: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.loadingLabel"
        })
      }) : /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "300",
        children: [featureName ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "upgrades.activationModal.headBackToFeature",
          options: {
            featureName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.trialStartSubtitle"
        }), /*#__PURE__*/_jsx(View, {
          inlineSize: "170px",
          children: /*#__PURE__*/_jsx(TrialRedirectButton, {
            block: true,
            use: "primary",
            onClick: onSuccess,
            buttonText: ctaText,
            upgradeData: upgradeData
          })
        })]
      })
    })
  });
};
export default ActivationSuccessFooter;